import React, { FC } from 'react';
import { Flex } from '@resideo/blueprint-react';
import { HeaderContainer, HeaderLogo, HeaderButton } from './Header.style';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiMenu, FiX } from 'react-icons/fi';
import useMedia from 'hooks/useMedia';
import { useGlobalProvider } from '../GlobalVisualProvider';

interface HeaderType {
  isAuthenticated: boolean;
}

const MobileMenuButton = ({ menuIconSize = 32 }) => {
  const { setLeftNavOpen, leftNavOpen } = useGlobalProvider();
  const IconComponent = leftNavOpen ? FiX : FiMenu;
  return (
    <Flex onClick={() => setLeftNavOpen(!leftNavOpen)}>
      <IconComponent stroke='#fff' size={menuIconSize} />
    </Flex>
  );
};

const Header: FC<HeaderType> = ({ isAuthenticated }) => {
  const { t } = useTranslation();
  const isMobile = useMedia('(max-width: 62rem)');
  const menuIconSize = 32;

  const { openLogoutModal } = useGlobalProvider();

  return (
    <HeaderContainer data-test-header>
      {isMobile && <MobileMenuButton {...{ menuIconSize }} />}
      <Flex>
        <NavLink to='/' title='Resideo Logo'>
          <HeaderLogo data-test-header-logo />
        </NavLink>
      </Flex>
      {!isMobile ? (
        <Flex>
          {isAuthenticated && (
            <HeaderButton
              data-test-sign-out-header-button
              variant='tertiary'
              onClick={openLogoutModal}>
              {t('header.signout')}
            </HeaderButton>
          )}
        </Flex>
      ) : (
        // this div is used to help us center the logo while on mobile
        // because the container is set to: justify-content: space-between;
        <div style={{ width: menuIconSize }} />
      )}
    </HeaderContainer>
  );
};

export default Header;
